export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11675.29c69362.jpg";